import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { DegreeType, RightType } from "../types/general";
import { BINARY_COURSES_NUM, IS_IN_MILUIM, RIGHTS_OF_3_WEEK_FIRST, RIGHTS_OF_3_WEEK_SECOND, RIGHTS_OF_50_DAYS, RIGHTS_OF_200_DAYS } from "./config";

const moment = extendMoment(Moment);

export const SEMESTER_A_START_DATE_FOR_SHANA_C_AND_UP = moment('2023-12-26')
export const SEMESTER_A_END_DATE = moment('2024-05-03')
export const SEMESTER_A_PERIOD_FOR_SHANA_C_AND_UP = moment.range(SEMESTER_A_START_DATE_FOR_SHANA_C_AND_UP, SEMESTER_A_END_DATE).snapTo('day');

export const dentalSpecialHakalot = new Map(
    [
        [101, "פטור מקורס אבן פינה. במידה ובוצעו כל קורסי אבני הפינה ניתן יהיה לקבל פטור מקורס 97312"],
        [102, "פטור מקורס סמינר בוגר"],
        [103, "פטור תורנות סליגמן"],
        [104, "פטור מקורס 97357 מדעי ההתנהגות"],
        [105, "פטור מקורס 97707"],
        [106, "המרת עבודת גמר בסקירת ספרות"],
        [108, "קיצור ימי תורנות אחת ביומיים (כלומר תורנות של 3 ימים במקום 5)"],
        [109, "קיצור נוסף של תורנות אחת ביומיים (כלומר עוד תורנות של 3 ימים במקום 5)"],
        [110, "קיצור שתי תורנויות ביומיים (כלומר 2 תורנויות של 3 ימים במקום 5)"],
        [111, "פטור מקורס בחירה בשווי נקודת זכות 1"],
        [112, "המרת עבודת גמר בסקירת ספרות + פטור מקורס בחירה בשווי נקודת זכות 1"],
        [113, "פטור מקורסי בחירה או אבני פינה בהיקף של 2 נקודות זכות"],
        [114, "פטור מקורס בחירה בשווי 2 נקודות זכות"],
        [115, "קיצור שתי תורנויות ביומיים (כלומר 2 תורנויות של 3 ימים במקום 5) + המרת עבודת גמר בסקירת ספרות"],
        [116, "קיצור ימי תורנות אחת ביומיים (כלומר תורנות של 3 ימים במקום 5) + המרת עבודת גמר בסקירת ספרות"],
    ]
)

export const DentalRightsConfig = new Map(
    [
        [IS_IN_MILUIM, new Map(
            [
                [DegreeType.DentalBogerShanaA, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.AvneyPina, 2],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.AvneyPina, 2],
                                [BINARY_COURSES_NUM, 5]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.AvneyPina, 2],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_200_DAYS, new Map(
                            [
                                [BINARY_COURSES_NUM, 6]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalBogerShanaB, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 101],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 101],
                                [BINARY_COURSES_NUM, 5]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.DentalRight, 101],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_200_DAYS, new Map(
                            [
                                [BINARY_COURSES_NUM, 6]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalBogerShanaC, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 103],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 104],
                                [BINARY_COURSES_NUM, 5]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.DentalRight, 102],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_200_DAYS, new Map(
                            [
                                [BINARY_COURSES_NUM, 6]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalDoctorShanaD, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 105],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 105],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.DentalRight, 105],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalDoctorShanaE, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 116],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 109],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.DentalRight, 106],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalDoctorShanaF, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 115],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 111],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.DentalRight, 106],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalMusmach, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 114],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 111],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.NekudotZehut, 0],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                    ]
                )],
            ]
        )],
        [!IS_IN_MILUIM, new Map(
            [
                [DegreeType.DentalBogerShanaA, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 113],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 113],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.NekudotZehut, 0],
                                [BINARY_COURSES_NUM, 0]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalBogerShanaB, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 113],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 113],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.NekudotZehut, 0],
                                [BINARY_COURSES_NUM, 0]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalBogerShanaC, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 113],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 113],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.NekudotZehut, 0],
                                [BINARY_COURSES_NUM, 0]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalDoctorShanaD, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 105],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 105],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.NekudotZehut, 0],
                                [BINARY_COURSES_NUM, 0]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalDoctorShanaE, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 106],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 106],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.NekudotZehut, 0],
                                [BINARY_COURSES_NUM, 0]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalDoctorShanaF, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 106],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 111],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.NekudotZehut, 0],
                                [BINARY_COURSES_NUM, 0]
                            ]
                        )],
                    ]
                )],
                [DegreeType.DentalMusmach, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [RightType.DentalRight, 111],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [RightType.DentalRight, 111],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [RightType.NekudotZehut, 0],
                                [BINARY_COURSES_NUM, 0]
                            ]
                        )],
                    ]
                )],
            ]
        )],
    ]
);
